import React from "react";

export const WaterBottleSvg = ({ width, height }) => {
  return (
    <svg
      fill="#000000"
      height={height}
      width={width}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <path
            d="M502.209,57.021L454.968,9.779c-13.023-13.022-34.216-13.023-47.24,0.001l-30.367,30.367
			c-32.091-21.308-76.273-18.21-105.113,10.631l-47.24,47.241c-10.469,10.469-15.321,24.456-14.57,38.191l-41.722,41.722
			c-13.735-0.75-27.721,4.1-38.19,14.569c-5.666,5.666-110.549,110.55-115.874,115.874c-19.537,19.536-19.537,51.324,0,70.861
			l118.101,118.1c19.537,19.537,51.324,19.536,70.86,0c5.328-5.328,110.207-110.205,115.875-115.873
			c10.468-10.469,15.32-24.455,14.569-38.19l41.722-41.722c14.237,0.778,28.054-4.435,38.19-14.57l47.24-47.24
			c28.857-28.857,31.929-73.038,10.631-105.112l30.365-30.365C515.262,91.21,515.266,70.076,502.209,57.021z M179.995,473.716
			c-6.529,6.528-17.092,6.528-23.62,0L38.273,355.615c-6.526-6.526-6.528-17.093,0-23.621l45.014-45.014l141.721,141.722
			L179.995,473.716z M295.869,357.841l-47.241,47.241L106.907,263.36l47.24-47.24c6.513-6.513,17.11-6.512,23.621-0.001
			L295.869,334.22C302.381,340.733,302.381,351.33,295.869,357.841z M319.489,310.6L201.388,192.499l23.62-23.62l118.101,118.1
			L319.489,310.6z M437.591,216.12l-47.24,47.24c-6.512,6.512-17.107,6.513-23.62,0L248.628,145.259
			c-6.513-6.513-6.513-17.108,0-23.621l47.241-47.24c19.585-19.585,51.276-19.584,70.86,0l70.861,70.861
			C457.172,164.841,457.174,196.534,437.591,216.12z M449.4,109.83c-5.006-5.006-42.233-42.234-47.24-47.241L431.348,33.4
			l47.24,47.241L449.4,109.83z"
          />
        </g>
      </g>
    </svg>
  );
};
